// Invoice keepers: the one predicate that says a document has left the
// building.
//
// KEEPERS ONLY. `InvoiceListItem`, `InvoiceStatus`, `InvoiceLineCategory` and
// the write shapes are generated (src/gen/client.ts) and re-exported by
// src/facade.ts.
/** Every state in which the document has left the building. */
export const ISSUED_STATUSES = [
    "issued",
    "paid",
    "void",
];
/**
 * An issued invoice is permanent: it cannot be amended and it cannot be
 * deleted, because a number that went out has to keep resolving to the document
 * it went out on. Every screen that hides an edit control asks this question.
 */
export function isIssued(status) {
    return ISSUED_STATUSES.includes(status);
}
//# sourceMappingURL=invoice.js.map